import { createAction, props } from '@ngrx/store';
import { Pagination } from '@shared/models/pagination.model';

import {
  DestroyListContent,
  DestroyRequestListContent,
  DestroyRequestSearchCriteria,
  DestroyRequestViewResponse,
  DestroyViewResponse
} from '../model/destroy-model';

export const DestroyAction = {
  destroyRequestListRequest: createAction(
    '[Destroy] Destroy Request List Request',
    props<{ payload: DestroyRequestSearchCriteria }>()
  ),
  destroyRequestListResponse: createAction(
    '[Destroy] Destroy Request List Response',
    props<{ response: Pagination<DestroyRequestListContent> }>()
  ),
  resetDestroyRequestList: createAction('[Destroy] Reset Destroy Request List'),
  destroyRequestViewRequest: createAction(
    '[Destroy] Destroy Request View Request',
    props<{ payload: { docNo: string } }>()
  ),
  destroyRequestViewResponse: createAction(
    '[Destroy] Destroy Request View Response',
    props<{ response: DestroyRequestViewResponse }>()
  ),
  resetDestroyRequestView: createAction('[Destroy] Reset Destroy Request View'),
  destroyListRequest: createAction(
    '[Destroy] Destroy List Request',
    props<{ payload: DestroyRequestSearchCriteria }>()
  ),
  destroyListResponse: createAction(
    '[Destroy] Destroy List Response',
    props<{ response: Pagination<DestroyListContent> }>()
  ),
  resetDestroyList: createAction('[Destroy] Reset Destroy List'),
  destroyViewRequest: createAction('[Destroy] Destroy View Request', props<{ payload: { docNo: string } }>()),
  destroyViewResponse: createAction('[Destroy] Destroy View Response', props<{ response: DestroyViewResponse }>()),
  resetDestroyView: createAction('[Destroy] Reset Destroy View')
};
